import { lazy } from 'react';

import { lazyNamed } from 'src/utils/lazyNamed';

const Sales = {
  Helmet: lazy(() => import('./components/Helmet')),
  Activities: {
    Activities: lazyNamed(() => import('./containers/Activities/pages/Activities'), 'Activities'),
    ActivityForm: lazyNamed(() => import('./containers/Activities/pages/ActivityForm'), 'ActivityForm'),
    Comments: lazyNamed(() => import('./containers/Activities/pages/Comments'), 'Comments'),
  },
  RoleBasedRedirector: lazy(() => import('./components/RoleBasedRedirector')),

  Promotions: {
    List: lazy(() => import('./containers/Promotions/pages/PromotionList')),
    TypeConfigList: lazy(() => import('./containers/Promotions/pages/TypeConfigList')),
    Create: lazy(() => import('./containers/Promotions/pages/PromotionForm/Create')),
    Edit: lazy(() => import('./containers/Promotions/pages/PromotionForm/Edit')),
    AddAccounts: lazy(() => import('./containers/Promotions/pages/PromotionAddAccounts')),
    AddContacts: lazy(() => import('./containers/Promotions/pages/PromotionAddContacts')),
    MailTemplate: lazy(() => import('./containers/Promotions/pages/PromotionMailTemplate')),
    Layout: lazy(() => import('./containers/Promotions/components/Layout')),
  },

  PromotionsV2: {
    Promotions: lazyNamed(() => import('./containers/PromotionsV2/pages/Promotions'), 'Promotions'),
    TypeConfigs: lazyNamed(() => import('./containers/PromotionsV2/pages/TypeConfigs'), 'TypeConfigs'),
    ManagePromotion: lazyNamed(() => import('./containers/PromotionsV2/pages/ManagePromotion'), 'ManagePromotion'),
    PromotionDetails: lazyNamed(() => import('./containers/PromotionsV2/pages/PromotionDetails'), 'PromotionDetails'),
    PromotionMailTemplate: lazyNamed(() => import('./containers/PromotionsV2/pages/PromotionMailTemplate'), 'PromotionMailTemplate'),
    PromotionAddAccounts: lazyNamed(() => import('./containers/PromotionsV2/pages/PromotionAddAccounts'), 'PromotionAddAccounts'),
    PromotionAddContacts: lazyNamed(() => import('./containers/PromotionsV2/pages/PromotionAddContacts'), 'PromotionAddContacts'),
  },

  PromotionDetails: {
    Layout: lazy(() => import('./containers/Promotions/pages/Promotion/Layout')),
    Renderer: lazy(() => import('./containers/Promotions/pages/Promotion')),
    Providers: lazy(() => import('./containers/Promotions/components/PromotionDetailsProviders')),
  },

  Settings: {
    SalesfunnelLabels: lazyNamed(() => import('./containers/Settings/containers/SalesfunnelLabels'), 'SalesfunnelLabels'),
    Sources: lazyNamed(() => import('./containers/Settings/containers/Sources'), 'Sources'),
    TaskTopics: lazyNamed(() => import('./containers/Settings/containers/TaskTopics'), 'TaskTopics'),
  },

  Tasks: {
    Details: lazyNamed(() => import('./containers/Tasks/pages/TaskDetails'), 'TaskDetails'),
    Form: lazyNamed(() => import('./containers/Tasks/pages/TaskForm'), 'TaskForm'),
    Tables: lazyNamed(() => import('./containers/Tasks/pages/TaskTables'), 'TaskTables'),
  },
};

export default Sales;
